import React from 'react';

const TermsOfService = () => {
  return (
    <div className="container mt-5 pt-5 mb-5">
      <h1>Terms of Service</h1>
      <p className="text-muted">Last Updated: April 2026</p>
      
      <section className="mt-4">
        <h3>1. Acceptance of Terms</h3>
        <p>
          By accessing and using the Trust Global website, you agree to be bound by these Terms of Service. 
          If you do not agree with any part of these terms, you are prohibited from using our site and services.
        </p>

        <h3 className="mt-4">2. Account Responsibilities</h3>
        <p>
          If you create an account on our website, you are responsible for maintaining the confidentiality 
          of your account and password and for restricting access to your computer. You agree to accept 
          responsibility for all activities that occur under your account or password.
        </p>

        <h3 className="mt-4">3. Products and Pricing</h3>
        <p>
          We strive to ensure that all details, descriptions, and prices of products appearing on the website 
          are accurate. However, errors may occur. If we discover an error in the price of any goods which 
          you have ordered, we will inform you of this as soon as possible and give you the option of reconfirming 
          your order at the correct price or canceling it.
        </p>
        <p>
          We reserve the right to modify or discontinue a product without notice at any time. Prices for our 
          products are subject to change without notice.
        </p>

        <h3 className="mt-4">4. Return and Refund Policy</h3>
        <p>
          Your purchase is strictly governed by our <strong>Refund Policy</strong>. As a general rule, all sales 
          are final, and we do not offer refunds, returns, or exchanges unless explicitly stated on the 
          individual product page or in the case of damaged/defective items upon arrival. By making a purchase, 
          you acknowledge and agree to this policy.
        </p>

        <h3 className="mt-4">5. Limitation of Liability</h3>
        <p>
          In no event shall Trust Global, its directors, employees, or affiliates be liable for any direct, 
          indirect, incidental, special, or consequential damages arising out of or in connection with your 
          use of the site or products purchased from the site.
        </p>

        <h3 className="mt-4">6. Contact Information</h3>
        <p>
          Questions about the Terms of Service should be sent to us at <strong>info@trustglobal.com.bd</strong>.
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;